import type { LinkToModulePageSignature } from '@efdigital/ll-addon-content/types/components/parts/link-to-module-page';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { LinkTo } from '@ember/routing';

const LinkToModulePage: TemplateOnlyComponent<LinkToModulePageSignature> =
  <template>
    <LinkTo
      @route="programs.program.cohort.content.module.page"
      @models={{array @program.id @cohort.id @module.id @page.id}}
      ...attributes
    >{{yield}}</LinkTo>
  </template>;

export { LinkToModulePage };
